import { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../stores/store';
import {
  BlockWrapper,
  BlockWrapperBottomContainer,
  BlockWrapperTopContainer,
  Container,
  WelcomeExcerpt,
  WelcomeTitle,
} from './root.styles';
import { CountriesResponse } from '../../models/countriesModel';
import Button from '../../common/button/button.component';
import { generateLocaleRoute } from '../../utils/uri/uri.utils';
import { ReactComponent as WavingHandIcon } from '../../assets/waving-hand-emoji.svg';
import { LabelWrapper } from '../../common/input/input.styles';
import { TextLabel } from '../../common/typography/typography.styles';
import Select, { IDropdownItem } from '../../common/select/select.component';

const RootComponent = () => {
  const {
    localizationsStore: {
      availableCountries,
      selectedCountry,
      selectLocale,
      getCountryLocalizedTitle,
    },
  } = useStore();

  const [measuresOpen, setMeasuresOpen] = useState<boolean>(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const countryOptions = useMemo(
    () =>
      availableCountries?.map((c) => ({
        label: getCountryLocalizedTitle(c, true),
        value: c,
      })),
    [availableCountries, getCountryLocalizedTitle]
  );

  return (
    <Container>
      <BlockWrapper>
        <BlockWrapperTopContainer>
          <WelcomeTitle>
            <WavingHandIcon />
            {t('authorization_hello')} {t('authorization_welcome')}
          </WelcomeTitle>

          <WelcomeExcerpt>{t('authorization_supported_text')}</WelcomeExcerpt>
        </BlockWrapperTopContainer>
        <BlockWrapperBottomContainer>
          <Select
            id='countries'
            title={
              <LabelWrapper>
                <TextLabel>{t('authorization_current_cocation')}</TextLabel>
              </LabelWrapper>
            }
            items={countryOptions}
            defaultValue={countryOptions?.find(
              (x) => x.value.country_code === selectedCountry?.country_code
            )}
            isOpened={measuresOpen}
            setIsOpened={setMeasuresOpen}
            onChange={(item: IDropdownItem<CountriesResponse>) =>
              selectLocale(item.value)
            }
            placeholder={t('choose_country')}
            inputAppearence='button'
            shouldMatchWidthOfInput
            renderDropdownInPortal={false}
          />

          <Button
            size='large'
            type='submit'
            onClick={() => {
              navigate(generateLocaleRoute());
            }}>
            {t('continue')}
          </Button>
        </BlockWrapperBottomContainer>
      </BlockWrapper>
    </Container>
  );
};

export default observer(RootComponent);
